import React, {useState} from "react";
import BottomButtonWrapper from "./BottomButtonWrapper";
import Button from "./Button";
import {BiChevronRight} from "react-icons/bi";

const Guid=({hasBack,skipEnable,onSkip,onBack,theme='green',slides=[],closeGuid=()=>{},state,imageClass})=>{

    const [step,setStep]=useState(0);
    const handleStep=(step)=>{
        if(step!=slides.length){
            setStep(step)
        }else {
            closeGuid()
        }

    }


    return  <div className="w-full bg-white  z-30 py-5  right-0 h-screen fixed top-0 z-0 ">
        <div className="w-full scroll-content">

            {slides.map((slide,index)=>{
                return <div key={`slide-`+index}  className={` justify-center  items-center flex-col ${index===step ? 'flex ':'hidden'}`}>

                    <div className={`flex mb-10 mt-2 items-center w-full px-4   ${hasBack ? 'justify-between' :'justify-center'}`}>
                        {(hasBack && index===0) ? <BiChevronRight className="text-2xl  " onClick={onBack}/>:<div/> }
                        <h1 className="text-2xl   text-gray-700  text-center  font-bold ">{ slide?.title}</h1>
                        {(hasBack && index===0) ? <BiChevronRight className="text-2xl  opacity-0" /> :<div/>}
                    </div>
                    <img className={`${imageClass} h-auto`} src={slide.image||slide.img_url} alt=""/>
                    <h3 className="font-bold mt-8 mb-3 text-xl">{slide.subTitle}</h3>
                    {slide?.warning&& <div className="px-3  w-11/12 lg:w-auto border-red-200  rounded-lg text-center  text-sm text-red-500"><p>{slide.warning}</p></div>}
                    {slide?.texts && <p className="1 text-center text-sm px-7   text-gray-500  w-11/12">{slide.texts}</p>}
                    <div className="w-11/12 mx-auto   lg:w-4/12 xl:w-3/12 ">
                        {slide?.tipsTitle && <p className="w-full border-t pt-2 mx-auto text-green-500 font-bold  mt-4 ">{slide.tipsTitle }</p>}
                        {slide.tips&&slide.tips.length>0 &&<ul className="text-sm list-decimal list-inside mt-1">{
                            slide.tips.map((tip,index)=><li className="py-1  font-bold">{tip}</li>)
                        }</ul>}
                    </div>


                </div>
            })}

        </div>
        {step===0}{
        <BottomButtonWrapper   grid={step===0 ? (skipEnable ? 2:1):2}>
            {step!==0 &&  <Button  onClick={()=>{handleStep(step-1)}} theme="link">قبلی</Button>}
            {step===0 && skipEnable &&  <Button  onClick={onSkip} rounded="rounded-lg" theme="light">کارت خودرو ندارم</Button>}
            {step!==slides.length-1&&<Button onClick={()=>{handleStep(step+1)}} rounded="rounded-lg" theme={theme}>بعدی</Button>}
            {step===slides.length-1&&<Button onClick={()=>{handleStep(step+1)}} rounded="rounded-lg" theme={theme}>ادامه</Button>}
        </BottomButtonWrapper>
             }

    </div>
}
export default Guid;